"use client";

import Script from "next/script";

declare global {
  interface Window {
    createLemonSqueezy?: () => void;
  }
}

export default function LemonSqueezyScript() {
  return (
    <Script
      src="https://assets.lemonsqueezy.com/lemon.js"
      strategy="afterInteractive"
      onReady={() => {
        // Its window.load listener may have already fired with afterInteractive.
        // Initialize once; React checkout links call Url.Open directly.
        if (!window.LemonSqueezy) window.createLemonSqueezy?.();
      }}
      onError={(error) => {
        console.warn("LemonSqueezy script failed to load:", error);
      }}
    />
  );
}
